import { Routes, Route } from "react-router-dom";
import { AppLayout } from "./layouts/AppLayout";
import { AuthLayout } from "./layouts/AuthLayout";
import DashboardPage from "./pages/dashboard";
import ForecastPage from "./pages/forecast";
import MapPage from "./pages/map";
import InsightsPage from "./pages/insights";
import AlertsPage from "./pages/alerts";
import PreparednessPage from "./pages/preparedness";
import ClothingPage from "./pages/clothing";
import ComparePage from "./pages/compare";
import CoastalPage from "./pages/coastal";
import AstronomyPage from "./pages/astronomy";
import NotificationsPage from "./pages/notifications";
import AccountPage from "./pages/account";
import AboutPage from "./pages/about";
import LogoPreviewPage from "./pages/logo-preview";
import LoginPage from "./pages/login";
import RegisterPage from "./pages/register";
import ForgotPasswordPage from "./pages/forgot-password";
import ResetPasswordPage from "./pages/reset-password";

export function App() {
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<RegisterPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
      </Route>
      <Route element={<AppLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/forecast" element={<ForecastPage />} />
        <Route path="/map" element={<MapPage />} />
        <Route path="/insights" element={<InsightsPage />} />
        <Route path="/alerts" element={<AlertsPage />} />
        <Route path="/preparedness" element={<PreparednessPage />} />
        <Route path="/clothing" element={<ClothingPage />} />
        <Route path="/compare" element={<ComparePage />} />
        <Route path="/coastal" element={<CoastalPage />} />
        <Route path="/astronomy" element={<AstronomyPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        <Route path="/account" element={<AccountPage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/logo-preview" element={<LogoPreviewPage />} />
      </Route>
    </Routes>
  );
}